import axios from 'axios'; //기본 Axios
import { apiClient } from './axiosConfig'; //토큰적용등 설정 반영된 커스텀axios
import { createApiFunction } from './createApiFunction';
import { API_BASE_URL } from './axiosConfig';
export type LoginRequestType = {
  loginId: string;
  password: string;
};
export type LoginResponseType = {
  accessToken: string;
  refreshToken: string;
  userInfo: {
    userName: string;
    role: string;
    loginId: string;
  };
};

/** 거래처타입 */
export type TraderType = {
  CUST_CODE: string; //거래처코드
  CUST_NAME: string; //거래처명
  BOSS_NAME: string; //대표자명
  TEL: string; //전화번호
  FAX: string; //팩스번호
  HP_NO: string; //모바일번호
  POST_NO: string; //우편번호
  ADDR: string; //주소
  updateFlag: boolean;
};

/** 주문목록 업데이트 post api dto
 * 참조 - 20250108 ~ 삭제예정
 * 내용 - 로직변경으로 추가개발 이후 해당 type은 사용하지 않을 예정
 */
export type OrderListUpdateRequestDto = {
  startDt: string;
  endDt: string;
  orderList: OrderListType[];
};

/** 주문 엑셀 업로드타입 - 신규*/
export type OrderListUpdateRequestType = {
  newOrders: OrderListType[];
  modifiedOrders: OrderListType[];
};

/** 주문 및 페이지네이션정보 묶음 컨테이너 타입 */
export type OrderPaginationWrapperType = {
  content: OrderListType[];
  pageable: PaginationState;
  last: boolean;
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  numberOfElements: number;
  empty: boolean;
};

/** 주문 및 페이지네이션 정보 묶음 요청 param 타입 */
export type OrderPaginationRequestParamType = {
  page: number;
  size: number;
  startDt: string;
  endDt: string;
  search: string;
  completeHidden: boolean;
};

/** 페이지네이션 정보 타입 */
export type PaginationState = {
  pageNumber: number;
  pageSize: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  offset: number;
  unpaged: boolean;
  paged: boolean;
};

//주문목록리스트
export type OrderListType = {
  id?: number;
  orderId?: number;
  IO_DATE?: string; //주문일자
  UPLOAD_SER_NO?: number; //주문시리얼
  ORDER_ID?: string; //20241104-1형식으로 부여하여서 주문 unique값으로 사용. 주문일자-시리얼 형태.
  CUST?: string; //거래처코드
  CUST_DES?: string; //거래처명
  abbr?: string; //거래처 약식명
  EMP_CD?: string; //담당자코드
  EMP_NAME?: string; //담당자명. 저장은 안하고 보여주는용도
  PROD_DES?: string; //품목명
  SIZE_DES?: string; //품목규격
  PROD_CD?: string; //품목코드
  CLASS_CD?: string; //품목그룹1코드
  CLASS_CD_DES?: string; //품목그룹1명 //저장안함
  CLASS_CD2?: string; //품목그룹2코드
  CLASS_CD2_DES?: string; //품목그룹2명
  CLASS_CD3?: string; //품목그룹3코드
  CLASS_CD3_DES?: string; //품목그룹3명
  QTY?: number; //수량
  PRICE?: number; //단가
  SUPPLY_AMT?: number; //공급가액
  TIME_DATE?: string; //납기일자
  ORDER_TYPE?: string; //주문방법
  DELIVERY_TYPE?: string; //배송방법
  DESCRIPTION?: string; //주문특이사항
  REMARKS?: string; //적요
  receiverAddress?: string; //실배송주소
  receiverAddressDetail?: string; //상세주소
  deliveryRemarks?: string;
  subRows?: OrderListType[];
  items?: OrderListType[];
  duplicated?: boolean;
  assignmentDate?: string;
  updateFlag?: boolean; //업데이트여부
  changedItemFields?: string[];
  changedOrderFields?: string[];
  locationType?: 'NEAR' | 'FAR';
  preparationState?: string;
  state?: number;
  deliveryOrder?: number;
  latitude?: number;
  longitude?: number;
};

/** 주문 주소검색 후 주소변경 요청타입 */
export type OrderAddressUpdateRequestType = {
  orderId: number;
  receiverAddress: string | null;
  receiverAddressDetail: string | null;
  latitude: number | null;
  longitude: number | null;
  zoneNo: string | null;
};

export const keyMapping: Record<string, keyof OrderListType> = {
  qty: 'QTY',
  price: 'PRICE',
  supplyAmt: 'SUPPLY_AMT',
  cust: 'CUST',
  custDes: 'CUST_DES',
  empCd: 'EMP_CD',
  empName: 'EMP_NAME',
  prodDes: 'PROD_DES',
  sizeDes: 'SIZE_DES',
  prodCd: 'PROD_CD',
  classCd: 'CLASS_CD',
  classCdDes: 'CLASS_CD_DES',
  classCd2: 'CLASS_CD2',
  classCd2Des: 'CLASS_CD2_DES',
  classCd3: 'CLASS_CD3',
  classCd3Des: 'CLASS_CD3_DES',
  timeDate: 'TIME_DATE',
  orderType: 'ORDER_TYPE',
  deliveryType: 'DELIVERY_TYPE',
  description: 'DESCRIPTION',
  remarks: 'REMARKS',
  receiverAddress: 'receiverAddress',
  deliveryRemarks: 'deliveryRemarks',
};

// 출고일정조회
// 하위 상품 정보를 위한 타입
export type SubRowType = {
  id: number;
  changedItemFields: any | null; // 변경된 필드 정보 (알 수 없어서 any로 지정)
  itemChangeFlag: any | null; // 변경 상태 플래그 (알 수 없어서 any로 지정)
  preparationState: string; // 준비 상태 (e.g., "준비중")
  loadingLocationId: number;
  loadingLocationName: string;
  PROD_ID: string; // 상품 ID
  QTY: number; // 수량
  PRICE: number; // 단가
  SUPPLY_AMT: number; // 공급 금액
  PROD_DES: string; // 상품 설명
  SIZE_DES: string | null; // 크기 설명 (없을 수도 있음)
};

// 메인 데이터 구조 타입
export type DeliveryScheduleResponseType = {
  state: number;
  changedOrderFields: any | null; // 변경된 필드 정보 (알 수 없어서 any로 지정)
  duplicated: boolean; // 중복 여부
  receiverAddressDetail: string | null; // 수령인 상세 주소
  receiverName: string | null; // 수령인 이름
  receiverTelNo: string | null; // 수령인 전화번호
  zoneNo: string | null; // 우편번호
  addressVerified: boolean; // 주소 검증 여부
  ORDER_ID: string; // 주문 ID
  receiverAddress: string | null; // 수령인 주소
  deliveryRemarks: string | null; // 배송 비고
  orderId: number; // 주문 ID
  IO_DATE: string; // 입출고 날짜
  UPLOAD_SER_NO: number; // 업로드 일련번호
  CUST: string; // 고객 번호
  CUST_DES: string; // 고객 설명
  EMP_CD: string; // 직원 코드
  EMP_NAME: string; // 직원 이름
  TIME_DATE: string; // 시간 날짜
  ORDER_TYPE: string; // 주문 유형
  DELIVERY_TYPE: string; // 배송 유형
  DESCRIPTION: string; // 설명
  REMARKS: string | null; // 비고
  subRows: SubRowType[]; // 하위 상품 정보 배열
  orderChageFlug: any | null; // 주문 변경 플래그 (알 수 없어서 any로 지정)
};

// 상차 장소 리스트트 조회 타입
export type LoadingLocationListResponseType = {
  id: number;
  name: string;
};

export type OrderUploadResponseType = {
  updatedOrInsertedOrders: OrderListType[];
  deletedItemsByOrderId: {
    [orderId in string]: string[];
  };
  deletedOrders: string[];
};
// 용법
//   const { fetch: apiGetTraderList } = useFetch({
//     fetchFunction: traderListGetApi,
//     onSuccess: (data: TraderType[]) => setData(data),
//   });
//   apiGetTraderList() --> 호출부

//   const { fetch: apiPostTraderList } = useFetch({
//     fetchFunction: traderListPostApi,
//     onSuccess: (data: TraderType[]) => {
//       setUpdatedData(data);
//       toast('업데이트에 성공하였습니다.');
//     },
//   });
//  apiPostTraderList(some_data) --> 호출부

/** 배송담당자 정보 타입 */
export type DeliveryManagerType = {
  id: number;
  name: string;
  position: string;
};

/** 작업장 정보 타입 */
export type WorkbayType = {
  id: number;
  workbayName: string;
  workbayCode: string;
};

/** 품목 반환타입 임시 */
export type ProductItem = {
  id: number;
  PROD_CD: string;
  PROD_DES: string;
  SIZE_DES: string;
  UNIT: string;
  PROD_TYPE: string;
  SET_FLAG: string;
  WH_CD: string;
  OUT_PRICE: string;
  REMARKS_WIN: string;
  REMARKS: string;
  abbr: string;
};

/** 생산 request dto */
export type ProductionType = {
  productionDt: string;
  workbayId: number;
  progress: string;
  phase: number;
  items: {
    itemId: number;
    goal: number;
  }[];
};

/** 생산일정 존재하는 날짜 조회 request dto */
export type ProductionExistDayReqType = {
  targetYear?: string;
  targetMonth?: string;
  targetDay?: string;
  targetWorkbayId?: number;
};

/** 생산일정 진행상태 업데이트 request dto */
export type ProductionProgressUpdateReqType = {
  progress: string;
  targetDate: string;
  workbayId: number;
};

/** 생산일정 응답타입 */
export type ProductionResponseType = {
  id: number;
  workbayId: string;
  workbayName: string;
  productionDt: string;
  productionCnt: number;
  productionGoal: number;
  productionPhase: number;
  progress: string;
  item: ProductItem;
};

/** 생산테이블 수량증가시의 response type */
export type ProductionCntIncreaseResponseType = {
  productionId: number;
  updatedCount: number;
};

/** 재고현황 응답 type */
export type StockResponseType = {
  itemId: number;
  prodCd: string;
  prodDes: string;
  qty: number;
  sizeDes: string;
  stockId: number;
  timeData: string;
};

/** 재고변동현황 응답 type */
export type StockHistoryResponseType = {
  id: number;
  productionId: number;
  stockId: number;
  itemId: number;
  timeDate: string;
  changedQuantity: number;
  prodCd: string;
};

/** 생산품과 별도로 설정할 수 있는 재고변동현황 */
export type UnsyncedStockHistoryResponseType = {
  id: number;
  workbayId: number;
  stockId: number;
  itemId: number;
  timeDate: string;
  changedQuantity: number;
  prodCd: string;
};

/** 배송배정 요청 타입 */
export type DeliveryAssignmentRequestType = {
  targetDt: string;
  data: DeliveryAssignmentRequestDataType[];
};

export type DeliveryAssignmentRequestDataType = {
  managerId: number;
  assignmentDate: string;
  orderIds: number[];
};

/** 배송배정 조건부조회 요청 body type */
export type DeliveryAssignmentRequestParamType = {
  startDt: string;
  endDt: string;
  manager: number[];
  custCode: string[];
};

/** BOM 타입 */
export interface ItemBomType {
  itemDes: string;
  sizeDes: string;
  itemId: number;
  bomId: number;
  consumedQty: number;
}

/** BOM ui용 타입 */
export type ItemBomEssType = {
  itemDes: string;
  sizeDes: string;
  itemId: number;
  bomId?: number;
  consumedQty?: number | string; // 타입 변경
};

/** BOM 묶음 */
export type ItemBomResponseType = {
  producedItem: ItemBomType;
  consumedItems: ItemBomType[];
};

/** BOM 묶음 ui용 타입 */
export type ItemBomResponseEssType = {
  producedItem: ItemBomEssType;
  consumedItems: ItemBomEssType[];
};

/** Bom request type */
export type BomRequestType = {
  producedItemId: number;
  consumedItems: {
    consumedItemId: number;
    consumedQuantity: number;
  }[];
};

/** 생산테이블 수량증가 request type */
export type ProductionCntIncrease = {
  productionId: number;
  increaseCount: number;
};

/** 생산테이블에 포함된 소모품현황 리스트 조회 요청타입*/
export type ProductionStockHistoryRequestType = {
  timeDate: string;
  workbayId: number;
};

/** 택배송장 품목 옵션값 post request type */
export type ParcelItemRequestType = {
  id: number;
  label: string;
  sizeLabel: string;
  unitLabel: string;
  packageMaxQty: number;
  prodCd: string;
};

/** 택배송장 품목 옵션값 get response type */
export type ParcelItemResponseType = {
  id: number | null;
  label: string | null;
  sizeLabel: string | null;
  unitLabel: string | null;
  packageMaxQty: number | null;
  prodCd: string;
};

/** 택배송장 거래처 옵션값 post request type */
export type ParcelTraderRequestType = {
  id: number;
  label: string;
  custCd: string;
};

/** 택배송장 거래처 옵션값 get response type */
export type ParcelTraderResponseType = {
  id: number | null;
  label: string | null;
  custCd: string | null;
};

/** 유저 정보 type */
export type UserType = {
  id: number | null;
  userName: string;
  role: string;
  loginId: string;
  password: string | null;
};

/** 자사쇼핑몰 주문 */
export type EmmShopOrder = {
  id: number; // emm_shop 테이블 고유 아이디
  orderId: string; // 주문 ID
  orderPrice: string; // 주문 총 금액 (상품 가격 합계)
  receiptPrice: string; // 실제 결제된 금액
  status: string; // 주문 상태 (주문, 입금, 배송, 완료 등)
  orderTime: string; // 주문 생성 시간
  invoiceNumber: string; // 운송장번호
  deliveryCompany: string; // 배송 회사 이름
  deliveryTime: string; // 배송 날짜 및 시간
  cancelPrice: string; // 취소된 금액
  couponTotal: number; // 쿠폰으로 할인된 금액(합계)
  outstandingAmount: string; // 미수금
  paymentMethod: string; // 결제방식(신용카드, 무통장 등)
  memo: string; // 주문 시 작성된 메모
  escrow: boolean; // 에스크로 여부
  ordererName: string; // 주문자의 이름
  ordererPhone: string; // 주문자의 전화번호
  ordererMobile: string; // 주문자의 휴대폰번호
  ordererEmail: string; // 주문자의 이메일
  ordererAddressZipcode: string; // 주문자의 주소 우편번호
  ordererAddressBase: string; // 주문자의 주소-기본주소
  ordererAddressDetail: string; // 주문자의 주소-상세주소
  ordererAddressOption: string; // 주문자의 주소-참고항목
  recipientName: string; // 수령인의 이름
  recipientPhone: string; // 수령인의 전화번호
  recipientMobile: string; // 수령인의 휴대폰번호
  recipientAddressZipcode: string; // 수령인의 주소 우편번호
  recipientAddressBase: string; // 수령인의 주소-기본주소
  recipientAddressDetail: string; // 수령인의 주소-상세주소
  recipientAddressOption: string; // 수령인의 주소-참고항목
  changeFlag: string; // 변경감지 여부 Y/N
  products: EmmShopOrderProduct[];
};

/** 자사쇼핑몰 주문의 품목타입 */
export type EmmShopOrderProduct = {
  productId: string;
  productName: string;
  quantity: string;
  price: string;
};

/** 생산테이블 약식조회 타입 */
export type ProductionSimpleType = {
  prodDes: string;
  sizeDes: string;
  qty: number;
  productionGoal: number;
  productionId: number;
  workbayId: number;
  productionDt: string;
  itemId: number;
};

/** 배송현황 미리보기 타입 */
export type DeliveryPreviewType = {
  id: number;
  deliveryPersonName: string;
  deliveryStatus: string;
  deliveryOrder: number;
  assignmentDate: string;
  custDes: string;
};

/** 스케줄러 전체 조회 타입 */
export type SchedulerType = {
  id?: number; //PK 아이디
  taskName: string; //테스크 이름
  state: number; //작업상태 1:정상 0:정지
  executionType: string; //동작 타입 예) TIME(시간),INTERVAL(주기)
  executionTime: string; //TIME일 경우 동작 시간
  fixedRate: number; //INTERVAL일경우 주기 (밀리초) 1000 = 1초
  cronExpression: string; //CRON 표현식
  taskDescription: string; //작업 설명
};

/** 주문의 ID값과 state만 담긴 타입 */
export type OrderStateResponseType = {
  ORDER_ID: string;
  state: number;
};

/** 주문 배송상태 index type */
export type OrderPreparationIndexType = {
  rowId: number;
  subRowId: number;
  preparationState: string;
};

/** 거래처 약칭 타입 */
export type TraderAbbrType = {
  CUST_CODE: string;
  CUST_DES: string;
  abbr: string;
};

/** 품목 약칭 타입 */
export type ItemAbbrType = {
  PROD_CD: string;
  PROD_DES: string;
  abbr: string;
};

/** 공지사항 조회 응답 컨테이너 타입 */
export type NoticeResponseType = {
  totalElements: number;
  totalPages: number;
  size: number;
  content: NoticeContentType[];
  number: number;
  sort: {
    empty: boolean;
    sorted: boolean;
    unsorted: boolean;
  };
  first: boolean;
  last: boolean;
  numberOfElements: number;
  pageable: {
    offset: number;
    sort: {
      empty: boolean;
      sorted: boolean;
      unsorted: boolean;
    };
    unpaged: boolean;
    pageNumber: number;
    paged: boolean;
    pageSize: number;
  };
  empty: boolean;
};

/** 공지사항 응답 컨텐츠 타입 */
export type NoticeContentType = {
  id: number;
  writer: string;
  loginId: string;
  title: string;
  detail: string;
  changeFlag: string;
  createdDate: Date;
  updatedDate: Date;
  categoryId: number;
  comment: NoticeCommentType[];
};

/** 공지사항 컨텐츠 수정/등록 타입 */
export type NoticeContentRequestType = {
  id: number | null;
  title: string;
  detail: string;
  categoryId: number | null;
};

/** 공지사항 댓글 수정/등록 타입 */
export type NoticeCommentRequestType = {
  id: number | null;
  noticeId: number;
  detail: string;
};

/** 공지사항 댓글 컨텐츠 타입 */
export type NoticeCommentType = {
  id: number;
  loginId: string;
  noticeId: number;
  detail: string;
  writer: string;
  changeFlag: string;
  createdDate: Date;
  updatedDate: Date;
};

/** 기간별 고객의 주문데이터 통계 응답타입 */
export type YearlyAnalysisRequestType = {
  startDt: string;
  endDt: string;
  filterItems: string[];
};

/** 기간별 고객의 주문데이터 통계 응답타입 */
export type YearlyAnalysisTableDataType = {
  custDes: string;
  qty: number;
  outPrice: number;
  division: string;
};

/** 기간별 잠재고객의 주문데이터 통계 요청타입 */
export type PotentialCustomerTableRequestType = {
  startDt: string;
  endDt: string;
};

/** 기간별 잠재고객의 주문데이터 통계 응답타입 */
export type PotentialCustomerTableDataType = {
  custName: string;
  addr: string;
  outPrice: number;
  dmndInsttDivNm: string;
};

/** 일정기간동안 거래처의 주문총액, 주문건수 응답 타입 */
export type TraderOrderRankChartDataType = {
  orderCount: number;
  orderAmount: number;
  custDes: string;
  custCode: string;
};

/** 기간동안의 월 총매출 및 주문건수 응답타입 */
export type OrderAnalysisChartDataType = {
  orderCount: number;
  orderAmount: number;
  year: string;
  month: string;
};

/** 기간동안의 품목별 판매수량 응답타입 */
export type ChartByProdAmountPriceDataType = {
  prodCd: string;
  prodDes: string;
  percent: number;
};

/** 기간동안의 월 총매출 및 주문건수를 기관(거래처)그룹명과 함께 받는 응답타입 */
export type ChartByCustomerGroupDataType = {
  orderCount: number;
  orderAmount: number;
  year: string;
  month: string;
  customerGroup: string;
};

/** 도넛차트에 들어갈 데이터 타입 */
export type PercentWithTitleType = {
  title: string;
  percent: number;
};

/** 문의사항 컨테이너 타입 */
export type InquiriesContainerType = {
  id: number;
  userLoginId: string;
  title: string;
  inquiriesItemDtos: InquiriesItemType[];
};

/** 문의사항 아이템 타입 */
export type InquiriesItemType = {
  id: number;
  content: string;
  readFlag: string;
  state: number;
  senderId: string;
  receiverId: string;
};

export type PeriodDto = {
  startDt: string;
  endDt: string;
};

export type MachineRequestDto = {
  id: number | null;
  name: string;
  identifier: string;
  workbayId: number;
};

export type MachineResponseDto = {
  id: number;
  name: string;
  identifier: string;
  workbay: WorkbayType;
};

export type UserMachineDto = {
  id: number;
  machineId: number;
  userId: number;
};

export type StockHistoryLogRequestType = {
  userIds: number[];
  startDt: string;
  endDt: string;
  unsyncedFlag: string | null;
};

/** 재고변동 건별 이력 */
export type StockHistoryLogType = {
  id: number;
  machineIdentifier: string;
  machineName: string;
  workbayName: string;
  role: string;
  userName: string;
  userId: number;
  prodCd: string;
  prodDes: string;
  sizeDes: string;
  unit: string;
  changedQuantity: number;
  date: string;
  producedDes: string;
};

/** 로그인 */
const loginApiConfig = async (data: LoginRequestType) => {
  const response = await axios.post(`${API_BASE_URL}/auth/login`, data);
  return response.data;
};
export const LoginApi = createApiFunction({
  apiCall: loginApiConfig,
});

/** 작업기계 리스트 조회 */
const machineListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/machine`);
  return response.data;
};
export const machineListGetApi = createApiFunction({
  apiCall: machineListGetApiConfig,
  errorMessage: () => '작업기계 목록을 불러오지 못했습니다',
});

/** 작업기계 생성/수정 */
const machinePostApiConfig = async (data: MachineRequestDto) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/machine`, data);
  return response.data;
};
export const machinePostApi = createApiFunction({
  apiCall: machinePostApiConfig,
  successMessage: (data: MachineResponseDto) =>
    `${data.name} 기계가 저장되었습니다`,
});

/** 작업기계 - 유저 연결 생성 */
const userMachinePostApiConfig = async (data: UserMachineDto) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/machine/user`,
    data
  );
  return response.data;
};
export const userMachinePostApi = createApiFunction({
  apiCall: userMachinePostApiConfig,
  successMessage: (data: any) => '저장되었습니다',
});

/** 작업기계 - 유저 연결 조회 */
const userMachineListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/machine/user`);
  return response.data;
};
export const userMachineListGetApi = createApiFunction({
  apiCall: userMachineListGetApiConfig,
  hideDefaultOnSuccess: true,
});

/** 재고변동 건별이력 조회 */
const stockHistoryLogGetApiConfig = async (
  data: StockHistoryLogRequestType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/stock-history-log`,
    data
  );
  return response.data;
};
export const stockHistoryLogGetApi = createApiFunction({
  apiCall: stockHistoryLogGetApiConfig,
  hideDefaultOnSuccess: true,
});

/** 계정생성 */
const userCreateApiConfig = async (data: UserType) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/signup`, data);
  return response.data;
};
export const userCreateApi = createApiFunction({
  apiCall: userCreateApiConfig,
  successMessage: (data: UserType) => `${data.loginId} 계정이 생성되었습니다`,
  errorMessage: (error, data: UserType) =>
    `${data.loginId} 계정을 생성하지 못했습니다`,
});

/** 유저리스트 조회 */
const userListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/user`);
  return response.data;
};
export const userListGetApi = createApiFunction({
  apiCall: userListGetApiConfig,
  errorMessage: () => '유저 목록을 불러오지 못했습니다',
});

/** 유저정보 업데이트 */
const userUpdateApiConfig = async (data: UserType) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/user`, data);
  return response.data;
};
export const userUpdateApi = createApiFunction({
  apiCall: userUpdateApiConfig,
  successMessage: (response, data: UserType) =>
    `${data.loginId} 계정의 정보가 수정되었습니다`,
  errorMessage: () => '유저 정보 업데이트에 실패했습니다',
});

/** 유저 삭제 */
const userDeleteApiConfig = async (loginId: string) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/delete-user`, {
    loginId,
  });
  return response.data;
};
export const userDeleteApi = createApiFunction({
  apiCall: userDeleteApiConfig,
  successMessage: (response, data: string) => `${data} 계정이 삭제되었습니다`,
  errorMessage: () => '유저 정보 삭제에 실패했습니다',
});

/** 코드기반 로그인 */
const loginByCodeApiConfig = async (code: string) => {
  const response = await axios.post(`${API_BASE_URL}/auth/login/code`, {
    code,
  });
  return response.data;
};
export const LoginByCodeApi = createApiFunction({
  apiCall: loginByCodeApiConfig,
});

/** 거래처목록 조회 */
const traderListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/trader`);
  return response.data;
};
export const traderListGetApi = createApiFunction({
  apiCall: traderListGetApiConfig,
  errorMessage: () => '거래처 목록을 불러오지 못했습니다',
});

/** 거래처목록 수정등록 */
const traderListPostApiConfig = async (data: LoginRequestType) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/trader`, data);
  return response.data;
};
export const traderListPostApi = createApiFunction({
  apiCall: traderListPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '거래처 정보 업데이트에 실패했습니다',
});

/** 거래처 약칭 전부 조회 */
const traderAbbrListGetApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/trader/abbreviation`
  );
  return response.data;
};
export const traderAbbrListGetApi = createApiFunction({
  apiCall: traderAbbrListGetApiConfig,
  errorMessage: () => '거래처 약칭목록을 불러오지 못했습니다',
});

/** 거래처 약칭 수정등록 */
const traderAbbrPostApiConfig = async (data: TraderAbbrType[]) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/trader/abbreviation`,
    data
  );
  return response.data;
};
export const traderAbbrPostApi = createApiFunction({
  apiCall: traderAbbrPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '거래처 약칭 업데이트에 실패했습니다',
});

/** 거래처 약칭 전부 조회 */
const itemAbbrListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/item/abbreviation`);
  return response.data;
};
export const itemAbbrListGetApi = createApiFunction({
  apiCall: itemAbbrListGetApiConfig,
  errorMessage: () => '품목 약칭목록을 불러오지 못했습니다',
});

/** 거래처 약칭 수정등록 */
const itemAbbrPostApiConfig = async (data: ItemAbbrType[]) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/item/abbreviation`,
    data
  );
  return response.data;
};
export const itemAbbrPostApi = createApiFunction({
  apiCall: itemAbbrPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '품목 약칭 업데이트에 실패했습니다',
});

/** 주문 상태를 완료(state 2)로 변경 */
const completeOrderGetApiConfig = async (orderId: string) => {
  const response = await apiClient.get(`${API_BASE_URL}/api/order/${orderId}`);
  return response.data;
};
export const completeOrderGetApi = createApiFunction({
  apiCall: completeOrderGetApiConfig,
  // successMessage: () => '저장되었습니다',
  errorMessage: () => '완료 처리에 실패했습니다',
});

/** 이카운트 주문목록 엑셀파일 업로드 api
 * 참조 - 20250108 ~  삭제예정
 * 내용 - 로직변경으로 인해 추가개발 이후 삭제예정
 */
const orderListPostApiConfig = async (data: OrderListUpdateRequestDto) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/order-excel`,
    data
  );
  return response.data;
};
export const orderListPostApi = createApiFunction({
  apiCall: orderListPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '주문목록 업데이트에 실패했습니다',
});

const orderListPostRequestApiConfig = async (
  data: OrderListUpdateRequestType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/order-excel`,
    data
  );
  return response.data;
};
export const orderListPostRequestApi = createApiFunction({
  apiCall: orderListPostRequestApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '주문목록 업데이트에 실패했습니다',
});

/** 이카운트 주문목록 조회 api */
const orderListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/order-list`);
  // console.log('response', response);
  return response.data;
};
export const orderListGetApi = createApiFunction({
  apiCall: orderListGetApiConfig,
  errorMessage: () => '주문목록을 불러오지 못했습니다',
});

/** 주문번호 전체 조회 */
const orderIdListGetApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/order-list-orderId`
  );
  // console.log('response', response);
  return response.data;
};
export const orderIdListGetApi = createApiFunction({
  apiCall: orderIdListGetApiConfig,
});

/** 이카운트 주문 - 기간, 검색어 기반 페이지네이션형식 조회 api */
const orderListWithParamApiConfig = async (
  data: OrderPaginationRequestParamType
) => {
  const { page, size, startDt, endDt, search, completeHidden } = data;
  const parameter = `page=${page}&size=${size}&startDt=${startDt}&endDt=${endDt}&search=${search}&completeHidden=${
    completeHidden ? 'true' : 'false'
  }`;
  const response = await apiClient.get(
    `${API_BASE_URL}/api/v2/order-list?${parameter}`
  );
  // console.log('response', response);
  return response.data;
};
export const orderListWithParamApi = createApiFunction({
  apiCall: orderListWithParamApiConfig,
  errorMessage: () => '주문목록을 불러오지 못했습니다',
});

/** 일정기간동안의 주문/주문품목을 완료/준비완료 상태로 변경 api */
const completeAllWithinPeriodConfig = async (data: PeriodDto) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/orders/complete-all-within-period`,
    data
  );

  return response.data;
};
export const completeAllWithinPeriod = createApiFunction({
  apiCall: completeAllWithinPeriodConfig,
  errorMessage: () => '주문완료 처리에 실패하였습니다',
});

/** 특정 주문ID들을 기반 주문/주문품목을 완료/준비완료 상태로 변경 api */
const completeAllInOrderIdsConfig = async (data: number[]) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/orders/complete-all-in-ids`,
    data
  );

  return response.data;
};
export const completeAllInOrderIds = createApiFunction({
  apiCall: completeAllInOrderIdsConfig,
  errorMessage: () => '주문완료 처리에 실패하였습니다',
});

/** 주문 삭제 */
const orderDeleteApiConfig = async (
  orderId: string //주문번호
) => {
  const response = await apiClient.delete(
    `${API_BASE_URL}/api/orders/${orderId}`
  );
  // console.log('response', response);
  return orderId;
};
export const orderDeleteApi = createApiFunction({
  apiCall: orderDeleteApiConfig,
  successMessage: (response, data) => `${data}주문이 삭제되었습니다`,
  errorMessage: () => '주문 삭제에 실패했습니다',
});

/** 주소 수정해야할 주문목록 조회 api */
const orderToVerifyAddressListGetApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/orders/unverified-address`
  );
  return response.data;
};
export const orderToVerifyAddressListGetApi = createApiFunction({
  apiCall: orderToVerifyAddressListGetApiConfig,
  errorMessage: () => '주문목록을 불러오지 못했습니다',
});

/** 주소 수정 api */
const orderAddressDataPutApiConfig = async (
  datas: OrderAddressUpdateRequestType[]
) => {
  const response = await apiClient.put(
    `${API_BASE_URL}/api/orders/unverified-address`,
    datas
  );
  return response.data;
};
export const orderAddressDataPutApi = createApiFunction({
  apiCall: orderAddressDataPutApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '주소 수정에 실패했습니다',
});

/** 배송담당자 전부 조회 api */
const deliveryManagerListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/delivery-persons`);
  return response.data;
};
export const deliveryManagerListGetApi = createApiFunction({
  apiCall: deliveryManagerListGetApiConfig,
  errorMessage: () => '배송담당자 조회에 실패했습니다',
});

/** 작업장정보 전부 조회 api */
const workbayListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/workbay`);
  return response.data;
};
export const workbayListGetApi = createApiFunction({
  apiCall: workbayListGetApiConfig,
  errorMessage: () => '작업장 목록을 불러오지 못했습니다',
});

/** 품목중 '제품'만 전부 조회 api */
const productItemListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/item-product`);
  return response.data;
};
export const productItemListGetApi = createApiFunction({
  apiCall: productItemListGetApiConfig,
  errorMessage: () => '품목 리스트를 불러오지 못했습니다',
});

/** 품목 전부 조회 api */
const itemListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/item`);
  return response.data;
};
export const itemListGetApi = createApiFunction({
  apiCall: itemListGetApiConfig,
  errorMessage: () => '품목 리스트를 불러오지 못했습니다',
});

/** 생산테이블저장 api */
const productionPostApiConfig = async (data: ProductionType) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/production`, data);
  return response.data;
};
export const productionPostApi = createApiFunction({
  apiCall: productionPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '생산테이블 저장에 실패했습니다',
});

/** 생산일정 존재하는 날짜 리스트 조회 */
const productionDaylistFindApiConfig = async (
  data: ProductionExistDayReqType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/production/day-list`,
    data
  );
  return response.data;
};
export const productionDaylistFindApi = createApiFunction({
  apiCall: productionDaylistFindApiConfig,
  errorMessage: () => '생산일정이 존재하는 날짜정보들을 불러오지 못했습니다',
});

/** 생산일정 조회 */
const productionListFindApiConfig = async (data: ProductionExistDayReqType) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/production/list`,
    data
  );
  return response.data;
};

export const productionListFindApi = createApiFunction({
  apiCall: productionListFindApiConfig,
  errorMessage: () => '생산일정을 불러오지 못했습니다',
});

/** 생산일정 진행상태 업데이트 */
const productionProgressUpdatePostApiConfig = async (
  data: ProductionProgressUpdateReqType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/production/progress`,
    data
  );
  return response.data;
};
export const productionProgressUpdatePostApi = createApiFunction({
  apiCall: productionProgressUpdatePostApiConfig,
  errorMessage: () => '생산 진행상태 변경에 실패했습니다',
  successMessage: (response, data) => {
    let progressText;
    // console.log('data:::', data);
    switch (data.progress) {
      case 'P':
        progressText = '진행중';
        break;
      case 'C':
        progressText = '마감';
        break;
      case 'E':
        progressText = '조기마감';
        break;
      default:
        progressText = '';
    }
    return progressText === ''
      ? '저장되었습니다'
      : `진행상태가 ${progressText}으로 변경되었습니다`;
  },
});

/** 배송배정 업데이트 */
const deliveryAssignmentUpdateApiConfig = async (
  data: DeliveryAssignmentRequestType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/delivery-assignment`,
    data
  );
  return response.data;
};
export const deliveryAssignmentUpdateApi = createApiFunction({
  apiCall: deliveryAssignmentUpdateApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '배송일정 저장에 실패했습니다',
});

/** 배송배정 조회 */
const deliveryAssignmentGetApiConfig = async (targetDate: string) => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/delivery-assignment?targetDt=${targetDate}`
  );
  return response.data;
};
export const deliveryAssignmentGetApi = createApiFunction({
  apiCall: deliveryAssignmentGetApiConfig,
  errorMessage: () => '배송일정을 불러오지 못했습니다',
});

/** 배송배정 조건부 조회 */
const deliveryAssignmentRequestApiConfig = async (
  data: DeliveryAssignmentRequestParamType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/delivery-assignment/detail`,
    data
  );
  return response.data;
};
export const deliveryAssignmentRequestApi = createApiFunction({
  apiCall: deliveryAssignmentRequestApiConfig,
  errorMessage: () => '배송일정을 불러오지 못했습니다',
});

/** 배송배정 되지 않은 && 배송방법 직배인 주문 조회 */
const deliveryTargetOrdersGetApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/orders/unassigned-delivery`
  );
  return response.data;
};
export const deliveryTargetOrdersGetApi = createApiFunction({
  apiCall: deliveryTargetOrdersGetApiConfig,
  errorMessage: () =>
    '배송일정이 정해지지 않은 주문목록들을 불러오지 못했습니다',
});

/** 출고일정  조회 */
const DeliveryScheduleGetApiConfig = async (data: {
  startDate: string;
  endDate: string;
}) => {
  const { startDate, endDate } = data; // 객체에서 추출
  const response = await apiClient.get(
    `${API_BASE_URL}/api/out-going?startDate=${startDate}&endDate=${endDate}`
  );
  return response.data;
};

export const DeliveryScheduleGetApi = createApiFunction({
  apiCall: DeliveryScheduleGetApiConfig,
  errorMessage: () => '출고일정을 불러오지 못했습니다',
});

/** 상차장소 리스트 조회 */
const LoadingLocationGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/loading-location`);
  return response.data;
};

export const LoadingLocationGetApi = createApiFunction({
  apiCall: LoadingLocationGetApiConfig,
  errorMessage: () => '상차장소 목록을 불러오지 못했습니다',
});

/** 상차장소 업데이트 */
const UpdateLoadingLocationPutApiConfig = async (data: {
  ordersItemId: number; // 품목 id
  loadingLocationId: number; // 상차 장소 id
}) => {
  const response = await apiClient.put(
    `${API_BASE_URL}/api/out-going/loading-location`,
    data
  );
  return response.data;
};

export const UpdateLoadingLocationPutApi = createApiFunction({
  apiCall: UpdateLoadingLocationPutApiConfig,
  errorMessage: () => '상차장소 등록에 실패했습니다',
});

/** 상차장소 등록 */
const LoadingLocationPostApiConfig = async (data: {
  name: string; // 상차 장소 이름름
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/loading-location`,
    data
  );
  return response.data;
};

export const LoadingLocationPostApi = createApiFunction({
  apiCall: LoadingLocationPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '상차장소 등록에 실패했습니다',
});

/** 출고 상태 변경 API */
const PreparationPutApiConfig = async (data: {
  id: number; // 품목 id
  rowId?: number;
  preparationState: string; // 출고 상태 명명
}) => {
  const response = await apiClient.put(
    `${API_BASE_URL}/api/preparation-state`,
    data
  );

  return response.data;
};

export const PreparationPutApi = createApiFunction({
  apiCall: PreparationPutApiConfig,
  successMessage: () => '출고상태가 변경되었습니다',
  errorMessage: () => '출고상태 변경에 실패했습니다',
});

/** 특정아이템 bom 조회 */
const itemBomListGetApiConfig = async (id: number) => {
  const response = await apiClient.get(`${API_BASE_URL}/api/item-bom/${id}`);
  return response.data;
};
export const itemBomListGetApi = createApiFunction({
  apiCall: itemBomListGetApiConfig,
  errorMessage: () => 'BOM목록을 불러오는데 실패했습니다',
});

/** 전체 bom 조회 */
const bomListGetApiConfig = async (id: number) => {
  const response = await apiClient.get(`${API_BASE_URL}/api/bom`);
  return response.data;
};
export const bomListGetApi = createApiFunction({
  apiCall: bomListGetApiConfig,
  errorMessage: () => 'BOM목록을 불러오는데 실패했습니다',
});

/** BOM 등록 */
const bomPostApiConfig = async (data: BomRequestType) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/bom`, data);
  return response.data;
};
export const bomPostApi = createApiFunction({
  apiCall: bomPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => 'BOM정보를 저장하는데 실패했습니다',
});

/** 생산테이블 수량증가 post */
const productionCntIncreaseApiConfig = async (data: ProductionCntIncrease) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/production/production-count`,
    data
  );
  return response.data;
};
export const productionCntIncreaseApi = createApiFunction({
  apiCall: productionCntIncreaseApiConfig,
  successMessage: (response, data: ProductionCntIncrease) => {
    //추후 0개는 api호출 안되도록 수정. 임시방편
    if (data.increaseCount === 0) {
      return '수량 변동이 없습니다';
    } else if (data.increaseCount < 0) {
      return `${data.increaseCount}개 만큼 차감되었습니다`;
    } else if (data.increaseCount > 0) {
      return `${data.increaseCount}개 만큼 추가되었습니다`;
    } else {
      return '';
    }
  },
});

/** 생산테이블 재고변동현황 조회 */
const productionStockHistoryFindApiConfig = async (
  data: ProductionStockHistoryRequestType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/production-stock-history`,
    data
  );
  return response.data;
};

export const productionStockHistoryFindApi = createApiFunction({
  apiCall: productionStockHistoryFindApiConfig,
});

/** 작업장 연동, 생산 비연동 재고변동현황 조회 */
const productionUnsyncedStockHistoryFindApiConfig = async (
  data: ProductionStockHistoryRequestType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/production-stock-history-unsynced`,
    data
  );
  return response.data;
};

export const productionUnsyncedStockHistoryFindApi = createApiFunction({
  apiCall: productionUnsyncedStockHistoryFindApiConfig,
});

/** 택배송장 품목 옵션값 전체조회 */
const parcelItemListAllGetApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/parcel-item-list-all`
  );
  return response.data;
};

export const parcelItemListAllGetApi = createApiFunction({
  apiCall: parcelItemListAllGetApiConfig,
  errorMessage: () => '품목 단축어 목록을 불러오지 못했습니다',
});

/** 택배송장 거래처 옵션값 전체조회 */
const parcelTraderListAllGetApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/parcel-trader-list-all`
  );
  return response.data;
};

export const parcelTraderListAllGetApi = createApiFunction({
  apiCall: parcelTraderListAllGetApiConfig,
  errorMessage: () => '거래처 단축어 목록을 불러오지 못했습니다',
});

/** 택배송장 품목 옵션값 품목코드로 조회 */
const parcelItemListGetApiConfig = async (data: string[]) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/parcel-item-list`,
    data
  );
  return response.data;
};

export const parcelItemListGetApi = createApiFunction({
  apiCall: parcelItemListGetApiConfig,
});

/** 택배송장 품목 옵션값 수정/등록 */
const parcelItemPostApiConfig = async (data: ParcelItemResponseType) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/parcel-item`,
    data
  );
  return response.data;
};
export const parcelItemPostApi = createApiFunction({
  apiCall: parcelItemPostApiConfig,
  successMessage: () => '저장되었습니다',
  errorMessage: () => '품목 단축어 저장에 실패했습니다',
});

/** 택배송장 거래처 옵션값 거래처코드로 조회 */
const parcelTraderListGetApiConfig = async (data: string[]) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/parcel-trader-list`,
    data
  );
  return response.data;
};

export const parcelTraderListGetApi = createApiFunction({
  apiCall: parcelTraderListGetApiConfig,
});

/** 택배송장 거래처 옵션값 수정/등록 */
const parcelTraderPostApiConfig = async (data: ParcelItemResponseType) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/parcel-trader`,
    data
  );
  return response.data;
};
export const parcelTraderPostApi = createApiFunction({
  apiCall: parcelTraderPostApiConfig,
  errorMessage: () => '거래처 단축어 저장에 실패했습니다',
});

/** 재고테이블 최종업데이트날짜 조회 */
const stockLatestUpdatedTimeGetApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/stock-updated-time`
  );
  return response.data;
};
export const stockLatestUpdatedTimeGetApi = createApiFunction({
  apiCall: stockLatestUpdatedTimeGetApiConfig,
});

/** 재고테이블 수동업데이트 */
const stockUpdateApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/stock`);
  return response.data;
};
export const stockUpdateApi = createApiFunction({
  apiCall: stockUpdateApiConfig,
  successMessage: () => '재고현황이 업데이트되었습니다',
  errorMessage: () => '재고현황 업데이트에 실패했습니다',
});

/** 품목테이블 수동업데이트 */
const itemUpdateApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/item-update`);
  return response.data;
};
export const itemUpdateApi = createApiFunction({
  apiCall: itemUpdateApiConfig,
  successMessage: () => '품목정보가 업데이트되었습니다',
  errorMessage: () => '품목정보 업데이트에 실패했습니다',
});

/** 나라장터 주문 수동업데이트 */
const govshopOrderPostToEcountApiConfig = async () => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/gov-shop-orders-dlvr`
  );
  return response.data;
};
export const govshopOrderPostToEcountApi = createApiFunction({
  apiCall: govshopOrderPostToEcountApiConfig,
});

/** 사용않음. 크롤링으로 변경 */
/** 나라장터 주문 수동업데이트 */
const emmshopOrderPostToEcountApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/emm-shop`);
  return response.data;
};
export const emmshopOrderPostToEcountApi = createApiFunction({
  apiCall: emmshopOrderPostToEcountApiConfig,
});

/** 자사쇼핑몰 changeFlag y 조회 */
const emmShopOrderListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/emm-shop-changed`);
  return response.data;
};
export const emmShopOrderListGetApi = createApiFunction({
  apiCall: emmShopOrderListGetApiConfig,
  errorMessage: () =>
    '변경사항이 감지된 자사쇼핑몰 주문목록을 불러오지 못했습니다',
});

/** 자사쇼핑몰 changeFlag Y 품목을 N으로 변경  */
const emmShopChangedOrderConfirmApiConfig = async (id: number) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/emm-shop/change-flag/${id}`
  );
  return id;
};
export const emmShopChangedOrderConfirmApi = createApiFunction({
  apiCall: emmShopChangedOrderConfirmApiConfig,
  errorMessage: () => '읽음처리에 실패했습니다',
});

/** 스케줄러 시작 */
const executeSchedulerPostApiConfig = async () => {
  const response = await apiClient.post(`${API_BASE_URL}/api/execute`);
  return response;
};
export const executeSchedulerPostApi = createApiFunction({
  apiCall: executeSchedulerPostApiConfig,
});

/** 독립 재고변동 생성 or 기존값 조회 */
const unsyncedStockHistoryPostApiConfig = async (data: {
  workbayId: number;
  itemId: number;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/unsynced-stock-history`,
    data
  );
  return response.data;
};
export const unsyncedStockHistoryPostApi = createApiFunction({
  apiCall: unsyncedStockHistoryPostApiConfig,
  errorMessage: () => '재고변동 관리데이터를 생성하지 못했습니다',
});

/** 독립 재고변동 수량변경 */
const unsyncedStockHistoryQtyPostApiConfig = async (data: {
  stockHistoryId: number;
  changedQty: number;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/unsynced-stock-history-qty`,
    data
  );
  return response.data;
};
export const unsyncedStockHistoryQtyPostApi = createApiFunction({
  apiCall: unsyncedStockHistoryQtyPostApiConfig,
  successMessage: (
    response,
    data: {
      stockHistoryId: number;
      changedQty: number;
    }
  ) => {
    //추후 0개는 api호출 안되도록 수정. 임시방편
    if (data.changedQty === 0) {
      return '수량 변동이 없습니다';
    } else if (data.changedQty < 0) {
      return `${data.changedQty}개 만큼 차감되었습니다`;
    } else if (data.changedQty > 0) {
      return `${data.changedQty}개 만큼 추가되었습니다`;
    } else {
      return '';
    }
  },
});

/** 일일생산 단순조회 */
const dailyProductionPreviewGetApiConfig = async (targetDate: string) => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/production-daily/${targetDate}`
  );
  return response.data;
};
export const dailyProductionPreviewGetApi = createApiFunction({
  apiCall: dailyProductionPreviewGetApiConfig,
  errorMessage: () => '오늘의 생산목록을 불러오지 못했습니다',
});

/** 일일생산 단순조회 */
const deliveryAssignmentDailyPreviewGetApiConfig = async (
  targetDate: string
) => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/delivery-assignment/daily?targetDt=${targetDate}`
  );
  return response.data;
};
export const deliveryAssignmentDailyPreviewGetApi = createApiFunction({
  apiCall: deliveryAssignmentDailyPreviewGetApiConfig,
  errorMessage: () => '오늘의 배송일정을 불러오지 못했습니다',
});

/** 일일생산을 기간범위로 조회 */
const productionBetweenDaysGetApiConfig = async (param: {
  startDate: string;
  endDate: string;
}) => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/production-between-days?startDate=${param.startDate}&endDate=${param.endDate}`
  );
  return response.data;
};
export const productionBetweenDaysGetApi = createApiFunction({
  apiCall: productionBetweenDaysGetApiConfig,
  errorMessage: () => '주간 생산현황을 불러오지 못했습니다',
});

/** 스케줄러 전체조회 */
const schedulerListGetApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/scheduler/all`);
  return response.data;
};
export const schedulerListGetApi = createApiFunction({
  apiCall: schedulerListGetApiConfig,
  errorMessage: () => '스케줄러 목록을 불러오지 못했습니다',
  // successMessage: (response: SchedulerType[], data) =>
  //   `${response[2].taskName}테스트`,
});

/** 스케줄러 일괄 업데이트 */
const schedulerUpdatePostApiConfig = async (data: SchedulerType[]) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/scheduler/update-batch`,
    data
  );
  return response.data;
};
export const schedulerUpdatePostApi = createApiFunction({
  apiCall: schedulerUpdatePostApiConfig,
  errorMessage: () => '스케줄러 목록을 불러오지 못했습니다',
  // successMessage: (response: SchedulerType[], data) =>
  //   `${response[2].taskName}테스트`,
});

/** 공지사항 조회 */
const noticeGetApiConfig = async ({
  page,
  size,
}: {
  page: number;
  size: number;
}) => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/notice?page=${page}&size=${size}`
  );
  return response.data;
};
export const noticeGetApi = createApiFunction({
  apiCall: noticeGetApiConfig,
  errorMessage: () => '공지사항을 불러오지 못했습니다',
});

/** 공지사항 등록/수정 */
const noticePostApiConfig = async (data: NoticeContentRequestType) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/notice`, data);
  return response.data;
};
export const noticePostApi = createApiFunction({
  apiCall: noticePostApiConfig,
  errorMessage: () => '게시글 등록에 실패했습니다',
});

/** 공지사항 삭제 */
const noticeDeleteApiConfig = async (noticeId: number) => {
  const response = await apiClient.delete(
    `${API_BASE_URL}/api/notice/${noticeId}`
  );
  return response.data;
};
export const noticeDeleteApi = createApiFunction({
  apiCall: noticeDeleteApiConfig,
  errorMessage: () => '게시글 삭제에 실패했습니다',
});

/** 공지사항 댓글 등록/수정 */
const noticeCommentPostApiConfig = async (data: NoticeCommentRequestType) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/notice-comment`,
    data
  );
  return response.data;
};
export const noticeCommentPostApi = createApiFunction({
  apiCall: noticeCommentPostApiConfig,
  errorMessage: () => '댓글 등록에 실패했습니다',
});

/** 공지사항 댓글 삭제 */
const noticeCommentDeleteApiConfig = async (commentId: number) => {
  const response = await apiClient.delete(
    `${API_BASE_URL}/api/notice-comment/${commentId}`
  );
  return commentId;
};
export const noticeCommentDeleteApi = createApiFunction({
  apiCall: noticeCommentDeleteApiConfig,
  errorMessage: () => '댓글 삭제에 실패했습니다',
});

/** 기간별 고객의 주문데이터 통계 요청 */
const yearlyAnalysisRequestApiConfig = async (
  data: YearlyAnalysisRequestType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/customer`,
    data
  );
  return response.data;
};
export const yearlyAnalysisRequestApi = createApiFunction({
  apiCall: yearlyAnalysisRequestApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 기간별 잠재고객의 주문데이터 통계 요청 */
const potentialCustomerRequestApiConfig = async (
  data: PotentialCustomerTableRequestType
) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/potential-customer`,
    data
  );
  return response.data;
};
export const potentialCustomerRequestApi = createApiFunction({
  apiCall: potentialCustomerRequestApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 거래처별 주문총액 및 주문건수 요청 api */
const traderRankGetRequestApiConfig = async (data: {
  startDt: string;
  endDt: string;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/trader`,
    data
  );
  return response.data;
};
export const traderRankGetRequestApi = createApiFunction({
  apiCall: traderRankGetRequestApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 기간동안의 월 총매출 및 주문건수 조회 api */
const monthlyResultGetRequestApiConfig = async (data: {
  startDt: string;
  endDt: string;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/monthly`,
    data
  );
  return response.data;
};
export const monthlyResultGetRequestApi = createApiFunction({
  apiCall: monthlyResultGetRequestApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 품목별 판매량 api */
const prodAmountPriceDataGetRequestApiConfig = async (data: {
  startDt: string;
  endDt: string;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/items`,
    data
  );
  return response.data;
};
export const prodAmountPriceDataGetRequestApi = createApiFunction({
  apiCall: prodAmountPriceDataGetRequestApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 기간동안의 월 총매출 및 주문건수를 기관(거래처)그룹명과 함께 요청 */
const monthlyGroupedResultRequestApiConfig = async (data: {
  startDt: string;
  endDt: string;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/customer-group`,
    data
  );
  return response.data;
};
export const monthlyGroupedResultRequestApi = createApiFunction({
  apiCall: monthlyGroupedResultRequestApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 주문방법 통계 api */
const orderTypePercentGetApiConfig = async (data: {
  startDt: string;
  endDt: string;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/order-method`,
    data
  );
  return response.data;
};
export const orderTypePercentGetApi = createApiFunction({
  apiCall: orderTypePercentGetApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 배송방법 통계 api */
const deliveryTypePercentGetApiConfig = async (data: {
  startDt: string;
  endDt: string;
}) => {
  const response = await apiClient.post(
    `${API_BASE_URL}/api/statistics/delivery-method`,
    data
  );
  return response.data;
};
export const deliveryTypePercentGetApi = createApiFunction({
  apiCall: deliveryTypePercentGetApiConfig,
  errorMessage: () => '통계정보를 불러오는데 실패했습니다',
});

/** 문의사항 컨테이너 조회 */
const inquiriesContainerApiConfig = async (userLoginId: string) => {
  const response = await apiClient.get(
    `${API_BASE_URL}/api/inquiries/${userLoginId}`
  );
  return response.data;
};
export const inquiriesContainerApi = createApiFunction({
  apiCall: inquiriesContainerApiConfig,
});

/** 문의사항 컨테이너 조회 */
const inquiriesContainerListApiConfig = async () => {
  const response = await apiClient.get(`${API_BASE_URL}/api/inquiries/all`);
  return response.data;
};
export const inquiriesContainerListApi = createApiFunction({
  apiCall: inquiriesContainerListApiConfig,
});

/** 과거 채팅 조회 */
const prevInquiriesItemListApiConfig = async ({
  groupId,
  lastItemId,
}: {
  groupId: number;
  lastItemId: number;
}) => {
  const response = await apiClient.post(`${API_BASE_URL}/api/inquiries/prev`, {
    groupId: groupId,
    lastItemId: lastItemId,
  });
  return response.data;
};
export const prevInquiriesItemListApi = createApiFunction({
  apiCall: prevInquiriesItemListApiConfig,
});
